//Creates new PlantTank and assigns ID and type
export const createBoxHolder = (data) => {
    //data = {id, type}
    return { type: "CREATE_BOX_HOLDER", payload: data}
}
